import React from 'react';
import { motion } from 'framer-motion';
import PaintTitle from './PaintTitle.js';
import headshot from '../assets/headshot.jpg';
import { DecryptingText } from '../effects.js';
import { academicSummary } from '../profileCopy.js';

function About({ themeId }) {
    const isCosmic = themeId === 'cosmic';

    const firstParagraph = "I got into engineering by modifying 3D printers - changing hardware, tuning firmware, and figuring out why the combination didn't work yet. That interest grew into robotics, embedded systems, and software. My projects range from a phone-controlled door unlocker to the storefront and operations tools behind Kianti Swim.";
    const secondParagraph = academicSummary;

    return (
        <section className="about-container" id="about">
            <motion.div
                className="about-content"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8 }}
            >
                <div className="about-text">
                    <PaintTitle>About me</PaintTitle>
                    {isCosmic ? (
                        <>
                            <DecryptingText>{firstParagraph}</DecryptingText>
                            <DecryptingText>{secondParagraph}</DecryptingText>
                        </>
                    ) : (
                        <>
                            <p>{firstParagraph}</p>
                            <p>{secondParagraph}</p>
                        </>
                    )}
                </div>
                <div className="about-image">
                    {<img src={headshot} alt="Kyle Perlman" />}
                </div>
            </motion.div>
        </section>
    );
}

export default About;
